import { Box, CircularProgress, Stack } from "@mui/material";
import {
  BaseSkeleton,
  ListSkeleton,
} from "src/shared/components/Skeleton/closet";

export default function AppSkeleton() {
  return (
    <Stack spacing={2} sx={{ position: "relative" }} data-testid="app-skeleton">
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: 1000,
          border: "1px solid #ccc",
          padding: 60,
        }}
      >
        <CircularProgress size={40} />
      </Box>
      <BaseSkeleton height={120} />
      <Box component="main" sx={{ flexGrow: 1, marginLeft: 3 }}>
        <ListSkeleton />
      </Box>
    </Stack>
  );
}
